import { api } from '../../../lib/api'

export const ADD_HOME_DECO_PRODUCT_DATA_REQUEST = 'ADD_HOME_DECO_PRODUCT_DATA_REQUEST'
export const ADD_HOME_DECO_PRODUCT_DATA_SUCCESS = 'ADD_HOME_DECO_PRODUCT_DATA_SUCCESS'
export const ADD_HOME_DECO_PRODUCT_DATA_FAILED = 'ADD_HOME_DECO_PRODUCT_DATA_FAILED'
export const HOME_DECO_CLEAR_ADD_PRODUCT = 'HOME_DECO_CLEAR_ADD_PRODUCT'

export const ADD_HOME_DECO_TEXTURES_SUCCESS = 'ADD_HOME_DECO_TEXTURES_SUCCESS'
export const ADD_HOME_DECO_TEXTURES_FAILED = 'ADD_HOME_DECO_TEXTURES_FAILED'

export const addHomeDecoProductData = function (productData) {
  return function (dispatch) {

    dispatch({
      type: ADD_HOME_DECO_PRODUCT_DATA_REQUEST
    })

    api.addHomeDecoProductData(productData).then(addHomeDecoProductDataResponse => {


      const textures = productData.textures;

      api.addTextures(textures, addHomeDecoProductDataResponse.data.payload._id).then(addTexturesResponse => {
        dispatch({
          type: ADD_HOME_DECO_PRODUCT_DATA_SUCCESS,
          payload: addHomeDecoProductDataResponse
        })
        // dispatch({
        //   type: ADD_HOME_DECO_TEXTURES_SUCCESS,
        //   payload: addTexturesResponse
        // })
      }).catch(error => {
        // dispatch({
        //   type: ADD_HOME_DECO_TEXTURES_FAILED,
        //   error
        // })
        dispatch({
          type: ADD_HOME_DECO_PRODUCT_DATA_FAILED,
          error
        })
      })
    }).catch(error => {
      dispatch({
        type: ADD_HOME_DECO_PRODUCT_DATA_FAILED,
        error
      })
    })


  }
}

export const clearHomeDecoAddProduct = function () {
  return function (dispatch) {
    dispatch({
      type: HOME_DECO_CLEAR_ADD_PRODUCT
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/add-home-deco-product-data.js